<!--begin::Body-->
<div class="kt-login__body auth-right">
	<div class="customer-logo w-100">
		<img [src]="imagePaths.uptimeLogoOriginal" *ngIf="!logoUrl" alt="uptime-logo" width="75em" />
		<img [src]="logoUrl" *ngIf="logoUrl" width="75em" alt="logo" />
	</div>
	<div class="kt-login__form form-body">
				<div class="kt-login__title center margin-0 w-470 d-flex align-items-center justify-content-center">
					<h5 class="sign-in-text">{{ 'AUTH.FORGOT.TITLE' | translate }}</h5>
				</div>

		<kt-auth-notice></kt-auth-notice>

		<form class="kt-form margin-0 w-470" [formGroup]="forgotPasswordForm" autocomplete="off">
			<div class="form-group my-3 form-entity d-flex flex-column">
				<kt-input
					[label]="'AUTH.INPUT.EMAIL' | translate"
					[placeholder]="'AUTH.PLACEHOLDER.EMAIL' | translate"
					formControlName="email"
					(inputBlur)="updateErrors()"
					[errorMessage]="emailErrorMessage">
				</kt-input>
			</div>
			<div class="my-5" *ngIf="recaptcha">
				<re-captcha (resolved)="resolved($event)" siteKey="{{siteKey}}"></re-captcha>
			</div>
			<!--begin::Action-->
			<div class="w-470 my-5">
				<kt-button-v1
					variant="flat"
					class="auth-btn w-100"
					[fullWidth]="true"
					(btnClick)="submit()"
					[label]="'AUTH.FORGOT.REQUEST_RESET_BUTTON' | translate"
					[disabled]="(isCaptchaSelected && recaptcha) || loading"
					[style.--auth-bg]="((isCaptchaSelected && recaptcha) || loading) ? '#8B8B8D' : '#6340D5'"
					[loading]="loading">
				</kt-button-v1>
			</div>
			<!--end::Action-->
			<div class="kt-extra-login__actions w-470 signup-head my-5"><a routerLink="/web/login" class="signin-back"
					id="kt_login_signup_cancel">{{ 'AUTH.FORGOT.BACK_TO_SIGNIN' | translate }}</a></div>
		</form>
	</div>
</div>
